import { UserInfoDb } from "@/types/UserInfo";

const LOCAL_USER_INFO_KEY = "userInfo";
export const userInfoDao = {
    getUserInfo: async (): Promise<UserInfoDb | null> => {
        const userInfo = localStorage.getItem(LOCAL_USER_INFO_KEY);
        return userInfo ? JSON.parse(userInfo) : null;
    },
    setUserInfo: async (userInfoDb: UserInfoDb) => {
        localStorage.setItem(LOCAL_USER_INFO_KEY, JSON.stringify(userInfoDb));
    },
    clearUserInfo: async () => {
        localStorage.removeItem(LOCAL_USER_INFO_KEY);
    },
}